<template>
  <div><TemaBrowser /></div>
</template>


<script setup>
import TemaBrowser from "@/components/irdr/TemaBrowser.vue";
import { useAppStore } from "@/store/app-store";

const appStore = useAppStore();
appStore.drawerExpanded = true;
</script>
 
